import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Skip to Main Content Link
 * WCAG 2.4.1 - Bypass Blocks
 * 
 * Provides keyboard users a way to skip repetitive navigation
 * and go directly to main content
 */
const SkipLink = () => {
  const handleSkip = (e) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleSkip}
      className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] focus:px-6 focus:py-3 focus:bg-ssdp-teal focus:text-white focus:font-bold focus:rounded-lg focus:shadow-lg focus:border-4 focus:border-ssdp-navy"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '0',
      }}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
